module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/place"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../../assets/maps.png")
    }
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/email"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../../assets/email.png")
    }
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/book-list"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../../assets/Book.png")
    }
  })]), _vm._v(" "), _c('hr')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d00e718a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/AppBar.vue
// module id = 296
// module chunks = 1